<template>
  <custom-callout :show-edition="item.editMode" class="mt-2">
    <div class="row">
      <div class="col-md-1 col-sm-2 icon-position px-0">
        <span class="fa-stack fa-1x force-orange">
          <i class="fas fa-circle fa-stack-2x" />
          <i class="fas fa-map-marker-alt fa-stack-1x fa-inverse" />
        </span>
      </div>
      <div class="col-md-11 col-sm-6 pl-2">
        <div class="row">
          <div class="col-md-4 col-sm-6 pt-0 border-right">
            <div class="row">
              <div class="col-md-6 col-sm-6 col-6 pt-0">
                <div class="regular">
                  Región:
                </div>
                <div class="regular text-black">
                  {{ item.region }}
                </div>
              </div>
              <div class="col-md-6 col-sm-6 col-6 pt-0">
                <div class="regular">
                  Distrito:
                </div>
                <div class="regular text-black">
                  {{ item.distrit }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-sm-6 col-6 pt-1">
                <div class="regular">
                  Escuela:
                </div>
                <div class="text-black">
                  {{ item.school }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-7 col-sm-12">
            <div class="row">
              <div class="col-md-4 col-sm-12 col-6 pt-0 mt-2 mt-md-0 mt-sm-2">
                <div class="regular">
                  Nombre:
                </div>
                <div class="regular text-black">
                  {{ item.name }}
                </div>
              </div>
              <div class="col-md-3 col-sm-12 col-6 pt-0 mt-2 mt-md-0 mt-sm-2">
                <div class="regular">
                  PEI:
                </div>
                <div class="regular text-black">
                  {{ item.PEI }}
                </div>
              </div>
              <div class="col-md-3 col-sm-12 col-6 pt-0 mt-2 mt-md-0 mt-sm-2">
                <div class="regular">
                  SIE:
                </div>
                <div class="regular text-black">
                  {{ item.SIE }}
                </div>
              </div>
              <div class="col-md-3 col-sm-12 col-6 pt-1 mt-2 mt-md-0 mt-sm-2">
                <div class="regular">
                  Servicio:
                </div>
                <div class="regular text-black">
                  {{ item.terapy }}
                </div>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-md-3 col-sm-12 col-6 pt-1">
                <div class="regular">
                  Servicio:
                </div>
                <div class="regular text-black">
                  {{ item.terapy }}
                </div>
              </div>
            </div> -->
          </div>
          <div class="col-md-1 col-sm-12 pt-3 pt-md-0 pt-sm-3">
            <div class="dropdown">
              <button
                class="btn btn-dropdown-actions dropdown-toggle pt-1 w-auto"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Acciones
              </button>
              <div class="dropdown-menu dropdown-menu-right py-0 mt-1">
                <a class="dropdown-item cursor-pointer" @click="onEditRow">
                  <i class="fas fa-edit text-green pr-1" />
                  <span>Editar</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="edition">
      <div class="row ml-2 py-2">
        <div class="col-12 pt-0">
          <span class="fa-stack fa-1x">
            <i class="fas fa-circle fa-stack-2x shadow-icon" />
            <i class="fas fa-edit fa-stack-1x fa-inverse text-green" />
          </span>
          <span class="text-gray-l">
            Editar
          </span>
        </div>
      </div>
      <div class="ml-5 mb-2 ml-n1 ml-md-3 ml-sm-0">
        <ValidationObserver ref="formValidator">
          <div class="row ml-1">
            <div class="col-md-2 col-sm-12 pt-0">
              <div class="regular text-gray">
                Acompañante:
              </div>
              <ValidationProvider
                v-slot="{ errors }"
                name="companion"
                rules="required"
              >
                <div class="pl-1 pt-1">
                  <div
                    class="custom-control custom-radio custom-control-inline"
                  >
                    <input
                      id="customRadioInline1"
                      v-model="item.companion"
                      type="radio"
                      value="1"
                      name="customRadioInline1"
                      class="custom-control-input"
                    />
                    <label
                      class="custom-control-label"
                      for="customRadioInline1"
                    >
                      Sí
                    </label>
                  </div>
                  <div
                    class="custom-control custom-radio custom-control-inline"
                  >
                    <input
                      id="customRadioInline2"
                      v-model="item.companion"
                      type="radio"
                      value="0"
                      name="customRadioInline1"
                      class="custom-control-input"
                    />
                    <label
                      class="custom-control-label"
                      for="customRadioInline2"
                    >
                      No
                    </label>
                  </div>
                  <div v-if="errors.length > 0" class="error">
                    <em class="fa fa-times-circle" />
                    {{ resources['21076'] }}
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-2 col-sm-12 pt-0">
              <div class="regular text-gray">
                Millaje:
              </div>
              <ValidationProvider v-slot="{ errors }" rules="required">
                <custom-input
                  v-model="item.mileage"
                  type="number"
                  :error="errors[0]"
                  :custom-error-msg="resources['21080']"
                />
              </ValidationProvider>
            </div>
            <div class="col-md-5 col-sm-12 pt-0">
              <div class="regular text-gray">
                Comentario
              </div>
              <ValidationProvider v-slot="{ errors }" rules="required">
                <custom-text-area
                  v-model="item.commentary"
                  show-char-count
                  :maxlength="500"
                  :error="errors[0]"
                  :custom-error-msg="resources['21081']"
                />
              </ValidationProvider>
            </div>
            <div class="col-md-3 col-sm-12 pt-4 pl-0 pr-4">
              <action-button
                class="fr px-4"
                text="Guardar"
                variant="success"
                @click="save"
              />
              <action-button
                class="fr mr-2"
                text="Cancelar"
                i="fa fa-times-circle"
                variant="outline-danger"
                @click="cancel"
              />
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from '@/components/common/CustomCallout';
import CustomInput from '@/components/common/CustomInput';
import CustomTextArea from '@/components/common/CustomTextArea';
import ActionButton from '@/components/common/ActionButton';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  name: 'Row',
  components: {
    CustomCallout,
    CustomInput,
    ActionButton,
    CustomTextArea,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    item: {
      type: Object,
      default: () => ({
        id: null,
        region: '',
        distrit: '',
        school: '',
        name: '',
        PEI: '',
        SIE: '',
        terapy: '',
        companion: null,
        mileage: null,
        commentary: null,
        editMode: false,
      }),
    },
    onSave: {
      type: Function,
      default: () => {},
    },
    resources: {
      type: Object,
      default: () => [],
    },
  },
  data: () => ({
    editing: false,
    maxlength: 500,
  }),
  methods: {
    async save() {
      const isValid = await this.$refs.formValidator.validate();
      if (isValid) {
        this.item.editMode = false;
        this.onSave(this.item);
      }
    },
    cancel() {
      this.item.editMode = false;
      this.item.companion = null;
      this.item.mileage = null;
      this.item.commentary = null;
    },
    onEditRow() {
      this.item.editMode = true;
      this.$emit('onEdit', this.item.id);
    },
  },
};
</script>

<style scoped>
.icon-position {
  max-width: 6%;
  padding-top: 35px;
  text-align: center;
}
.force-orange {
  color: #ff7058;
}
.text-gray-l {
  color: #3f5b60;
}
.text-gray {
  color: #727272;
}
.text-black {
  color: #11291b;
}
.divider-horizontal {
  border-right: 1px solid #e2e2e2;
}
.col-3-alt {
  max-width: 20%;
}
.shadow-icon {
  color: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 50px;
  width: 34px;
}
.error {
  letter-spacing: 0;
  color: #ff5b5c;
  margin-bottom: 0px;
  font-weight: normal;
  font-size: 14px;
}
</style>
